/** Minimum duration between auction start and end for english.reverse.continuous (specific time). */
export const REVERSE_CONTINUOUS_SPECIFIC_MIN_GAP_MINUTES = 30;

/** v-select value: open date/time pickers instead of a quick offset or duration */
export const SCHEDULE_SPECIFIC = 'SCHEDULE_SPECIFIC';

/** Shown in the select when specific mode has no valid date+time yet (or invalid input). */
export const SCHEDULE_SPECIFIC_LABEL = 'Specific time';

export const START_QUICK_OFFSET_ITEMS = [
  { text: 'In 20 min', value: 1000 * 60 * 21 },
  { text: 'In 30 min', value: 1000 * 60 * 30 },
  { text: 'In 45 min', value: 1000 * 60 * 45 },
  { text: 'In 1 hour', value: 1000 * 60 * 60 },
  { text: 'In 2 hours', value: 1000 * 60 * 60 * 2 },
];

export const START_SCHEDULE_OPTIONS = [
  ...START_QUICK_OFFSET_ITEMS,
  { text: SCHEDULE_SPECIFIC_LABEL, value: SCHEDULE_SPECIFIC },
];

export const END_SCHEDULE_OPTIONS = [
  { text: '30 min after start', value: 30 },
  { text: '45 min after start', value: 45 },
  { text: '1 hour after start', value: 60 },
  { text: SCHEDULE_SPECIFIC_LABEL, value: SCHEDULE_SPECIFIC },
];

/** Empty state for the auction items v-data-table */
export const AUCTION_FORM_ITEMS_TABLE_NO_DATA = 'No items added yet';
